import { render, staticRenderFns } from "./InsuranceFormStatusModal.vue?vue&type=template&id=584dde9e"
import script from "./InsuranceFormStatusModal.vue?vue&type=script&lang=js"
export * from "./InsuranceFormStatusModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports